import { render, staticRenderFns } from "./AddNewRincian.vue?vue&type=template&id=1cc4e299&"
import script from "./AddNewRincian.vue?vue&type=script&lang=js&"
export * from "./AddNewRincian.vue?vue&type=script&lang=js&"
import style0 from "./AddNewRincian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports